const DEFAULT_ANALTYICS_ROUTE = "dashboard";

export {DEFAULT_ANALTYICS_ROUTE};
